import VacationsAbsencesDelegations from 'vacations-absences.module/common/models/delegations';

class delegationDataAssembler {
  static assemble(dataArray) {
    let delegations = [];
    dataArray.delegations.forEach((data) => {
      let delegation = new VacationsAbsencesDelegations();
      delegation.startDate = data.startDate || '';
      delegation.endDate = data.endDate || '';
      delegation.employeeId = data.employeeId || '';
      delegation.name = data.name || '';
      delegation.email = data.email || '';
      delegation.isNotified = data.isNotified || false;
      delegation.id = data.id || '';
      delegations.push(delegation);
    });
    return delegations;
  }
}

export default delegationDataAssembler;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/common/delegationRepository/vacationDelegation.assemblers.js